<template>
    <div class="main-container">
        <Header></Header>
        <el-container>
            <el-aside :style="{ width: 'auto' }" class="el-aside">
                <!-- v-if="this.$route.path !== '/home'" -->
                <MenuBar></MenuBar>
            </el-aside>
            <menuDrawer></menuDrawer>
            <!-- <el-row type="flex">
            <div class="my-col">
              <el-tabs v-model="editableTabsValue"
                       @tab-remove="removeTab"
                       @tab-click="handleClickTab"
                       closable
                       type="card"
                       @edit="handleTabsEdit"
                       class="main-tabs">
                <el-tab-pane :key="index"
                             v-for="(item, index) in editableTabs"
                             :label="item.title"
                             :name="item.name"></el-tab-pane>
              </el-tabs>
            </div>
            <transition name="fade"
                        :duration="1000">
              <div v-if="editableTabs.length > 1">
                <el-dropdown @command="tabCommand">
                  <el-button style="padding: 9px 4px"
                             icon="el-icon-arrow-down"
                             size="small"></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="current">关闭当前标签</el-dropdown-item>
                    <el-dropdown-item command="right">关闭右侧</el-dropdown-item>
                    <el-dropdown-item command="left">关闭左侧</el-dropdown-item>
                    <el-dropdown-item command="all">关闭全部</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </transition>
          </el-row> -->
            <!-- </el-header> -->
            <el-main class="main-inner">
                <div class="main-content">
                    <keep-alive
                        :include="this.$store.state.whileList"
                        :exclude="this.$store.state.blackList"
                    >
                        <router-view></router-view>
                    </keep-alive>
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import Header from "./header";
import MenuBar from "./menu-bar";
import menuDrawer from "./menuDrawer";
import { mapState } from "vuex";
export default {
    name: "Main",
    components: {
        Header: Header,
        MenuBar: MenuBar,
        menuDrawer: menuDrawer,
    },
    data() {
        return {
            editableTabsValue: "",
            hasStatus: false,
            editableTabs: [],
            userRole: "",
        };
    },
    computed: {
        ...mapState({
            menuDrawerVisible: (state) => state.index.menuDrawerVisible
        }),
        menuList() {
            return JSON.parse(localStorage.getItem("menu_list"));
        },
    },
    created() {
        this.$store.dispatch("getUserInfo");
    },
    beforeRouteEnter(to, from, next) {
        const token = localStorage.getItem("token");
        if (to.name === "main" && !token) {
            next("/login");
        }
        return next((vm) => {
            if (to.path !== "/") {
                vm.hasStatus = false;
                if (vm.editableTabs.length) {
                    //   tab有值判断数组是否有重复值，没有直接添加，有的话，设置选中
                    vm.editableTabs.forEach((item) => {
                        if (item.title === to.meta.title) {
                            vm.hasStatus = true;
                        }
                    });
                    if (!vm.hasStatus) {
                        vm.editableTabs.push({
                            title: to.meta.title,
                            name: to.name,
                            path: to.fullPath,
                        });
                    }
                } else {
                    vm.editableTabs.push({
                        title: to.meta.title,
                        name: to.name,
                        path: to.fullPath,
                    });
                }
                if (!localStorage.getItem("activeTab")) {
                    localStorage.setItem("activeTab", to.name);
                }
                vm.editableTabsValue = to.name;
                localStorage.setItem(
                    "tabList",
                    JSON.stringify(vm.editableTabs)
                );
            }
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.hasStatus = false;
        if (this.editableTabs.length) {
            //   tab有值判断数组是否有重复值，没有直接添加，有的话，设置选中
            this.editableTabs.forEach((item) => {
                if (item.title === to.meta.title) {
                    this.hasStatus = true;
                }
            });
            if (!this.hasStatus) {
                this.editableTabs.push({
                    title: to.meta.title,
                    name: to.name,
                    path: to.fullPath,
                });
            }
        } else {
            this.editableTabs.push({
                title: to.meta.title,
                name: to.name,
                path: to.fullPath,
            });
        }
        this.editableTabsValue = localStorage.getItem("activeTab")
            ? localStorage.getItem("activeTab").replace("/", "")
            : to.name;
        this.editableTabsValue = to.name;
        localStorage.setItem("activeTab", this.editableTabsValue);
        if (JSON.parse(localStorage.getItem("tabList"))) {
            localStorage.setItem("tabList", JSON.stringify(this.editableTabs));
        } else {
            this.editableTabs = [
                {
                    title: to.meta.title,
                    name: to.name,
                    path: to.fullPath,
                },
            ];
            localStorage.setItem("tabList", JSON.stringify([]));
        }
        next();
    },
    // keepAlive缓存
    beforeRouteLeave(to, from, next) {
        if (from.meta.keepAlive) {
            this.$store.commit("add_whiteList", from.name);
            next();
        } else {
            this.$store.commit("add_blackList", from.name);
            next();
        }
    },
    mounted() {
        const tabList = JSON.parse(localStorage.getItem("tabList"));
        const tabActive = localStorage.getItem("activeTab");
        if (tabList) {
            this.editableTabs = tabList;
            this.editableTabsValue = tabActive;
        }
    },

    methods: {
        /**
         * 删除tab标签
         */
        removeTab(targetName) {
            if (targetName === "home") {
                return false;
            }
            let tabs = this.editableTabs;
            let activeName = this.editableTabsValue;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.name;
                        }
                    }
                });
            }
            this.editableTabsValue = activeName;
            this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
            let path = tabs.filter((tab) => tab.name === activeName)[0].path;
            localStorage.setItem("activeTab", this.editableTabsValue);
            localStorage.setItem("tabList", JSON.stringify(this.editableTabs));
            this.$router.push(path);
        },
        /**
         * 点击tab
         */
        handleClickTab(tab) {
            let menu_id = this.tabRecursion("/" + tab.name, this.menuList);
            localStorage.setItem("menu_id", menu_id);
            this.$store.commit("MENU_ID", menu_id);
            this.$store.dispatch("getMenuAuth");
            this.editableTabsValue = tab.name;
            localStorage.setItem("activeTab", this.editableTabsValue);

            this.$router.push("/" + tab.name);
        },
        /**
         * tab点击循环menulist获取menu_id的递归
         */
        tabRecursion(_target, list) {
            for (let i in list) {
                if (_target == list[i].url) {
                    return list[i].id;
                } else if (list[i].child && list[i].child.length) {
                    let func = this.tabRecursion(_target, list[i].child);
                    if (func) {
                        return func;
                    }
                }
            }
            return "";
        },
        /**
         * 获取重定向路由
         */
        getReplaceUrl(menuList) {
            if (menuList[0].childlist) {
                if (menuList[0].childlist[0].childlist) {
                    this.replaceUrl =
                        menuList[0].childlist[0].childlist[0].route_path;
                } else {
                    this.replaceUrl = menuList[0].childlist[0].route_path;
                }
            } else {
                this.replaceUrl = menuList[0].route_path;
            }
        },
        /**
         * 清楚所有选项卡
         */
        clearTabs() {
            this.$confirm("是否清除所有选项卡?", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.editableTabs = [
                        {
                            title: "首页",
                            name: "home",
                            path: "/home",
                        },
                    ];
                    localStorage.setItem(
                        "tabList",
                        JSON.stringify(this.editableTabs)
                    );
                    this.$router.push(this.editableTabs[0].path);
                    this.$message.success("清除成功！");
                })
                .catch(() => {
                    this.$message.info("已取消操作");
                });
        },
        // 关闭选项卡
        tabCommand(directive) {
            let _this = this;
            function mapTabs() {
                _this.editableTabs.map((item, index, arr) => {
                    if (item.name == _this.editableTabsValue) {
                        if (directive === "right") {
                            arr.splice(index + 1, arr.length - 1);
                        } else if (directive === "left") {
                            if (_this.editableTabsValue === "home") {
                                return false;
                            }
                            arr.splice(1, index - 1);
                        } else if (directive === "current") {
                            arr.splice(index, 1);
                            _this.editableTabsValue = arr[index - 1].name;
                            _this.$router.push(arr[index - 1].path);
                        }
                        // 设置session
                        localStorage.setItem(
                            "tabList",
                            JSON.stringify(_this.editableTabs)
                        );
                    }
                });
            }
            let strategyGroup = {
                current: () => {
                    mapTabs();
                },
                right: () => {
                    mapTabs();
                },
                left: () => {
                    mapTabs();
                },
                all: () => {
                    this.clearTabs();
                },
            };

            let action = (directive) => {
                strategyGroup[directive]();
            };
            action(directive);
        },
    },
};
</script>
<style lang="scss">
.main-container {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: $color-white;
    overflow: hidden;
    .main-tabs {
        z-index: 999;
        background: #fff;
        .el-tabs__item {
            padding: 0 20px;
            height: 30px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            line-height: 30px;
            display: inline-block;
            list-style: none;
            font-size: 12px;
            font-weight: 500;
            position: relative;
            &.is-active {
                border-bottom: 2px solid $color-primary;
            }
        }
        .el-tabs__header {
            margin: 0;
            .el-tabs__nav-wrap {
                background: #fff;
                .el-tabs__nav-prev,
                .el-tabs__nav-next {
                    top: 50% !important;
                    margin-top: -6px !important;
                    height: 100% !important;
                    line-height: 100% !important;
                }
            }
        }
        .el-tabs__nav-wrap {
            background: #fff;
        }
    }
    .el-aside {
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        background: $background-color-base;
        z-index: 201;
        .el-scrollbar .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
    .main-inner {
        width: 100%;
        // height: calc(100% - 8px);
        margin: 15px 0 0;
        box-sizing: border-box;
        position: relative;
        background: $color-white;
        padding: 0;
        .tabCont,
        .table {
            padding: 0 15px;
            * {
                font-size: 12px;
            }
            .el-image-viewer__wrapper {
                * {
                    font-size: 24px !important;
                }
            }
        }
        .tabCont {
            border-bottom: 1px solid #e4e7ed;
            margin-bottom: 10px;
            .el-tabs {
                position: relative;
                top: 1px;
                .el-tabs__nav {
                    border: 0;
                    .el-tabs__item {
                        background-color: #fff;
                        &.is-active,
                        &:hover {
                            background-color: #fafafa;
                            color: $color-text-primary;
                        }

                        &.el-tabs__item:first-child {
                            border-left: 1px solid #e4e7ed;
                        }
                        &.el-tabs__item:last-child {
                            border-right: 1px solid #e4e7ed;
                        }
                    }
                }
            }
        }
        .table {
            width: 100%;
            border-top: 1px solid #eee;
            border-right: 1px solid #eee;
            border-left: 1px solid #eee;
            box-sizing: border-box;
        }
        .main-content {
            height: 100%;
            .el-tabs__header {
                margin: 0;
            }
        }
    }
    .el-container {
        width: 100%;
        height: calc(100% - 50px);
        position: relative;
        overflow: hidden;
        z-index: 2000 !important;
        .v-modal {
            top: 50px;
            height: calc(100% - 50px);
            z-index: 1999 !important;
        }
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        transform: translateX(50px);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 1s;
    }

    .my-col {
        width: calc(100% - 22px);
        height: 30px;
    }
}
</style>
